import { LocationQueryValue, useRoute } from 'vue-router'

export class RouteUtil {
    /**
     * 
     * @param parameterName Name of the query parameter, of which to retrieve the value
     * @returns The value of the specified query parameter (null, if it does not exist)
     */
    static getRouteParam(parameterName: string): (string | null) {
        const route = useRoute();
        const value = route.query[parameterName] as LocationQueryValue;
        return value;
    }
}